import * as AUXILLIARY from './auxilliary'
import * as BRIDGEABLE from './bridgeable'
import * as DEPRECATED from './deprecated'

export const ALL_TOKENS = {
  ...AUXILLIARY,
  ...BRIDGEABLE,
  ...DEPRECATED,
}
